import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import EditBannerIcon from "./bannerData/EditIcon"
import useWindowSize from "../../util/custom-hooks/useWindowSize";
import BannerBtn from './bannerData/BannerBtn'
import BannerButton from './bannerData/BannerButton'

const HeroSliderOneItem = ({ data }) => {
	const [windowWidth] = useWindowSize();
	const [isSmallScreen, setIsSmallScreen] = useState(windowWidth < 992);
	const [buttonTextPL, setbuttonTextPL] = useState(data.buttonTextPL)
	let bannerId = data?._id;
	let bannerDiv = document.querySelector(".slider-area")
	let bannerWidth = (data?.background_mobile_image_size && windowWidth && windowWidth < 768) ? data?.background_mobile_image_size : data?.background_image_size

	const mystyle = {
		backgroundColor: data.btncolor,
		borderColor:data.btnBordercolor,
		// '&:hover':{
		// 	borderColor:data.buttonBorderHoverColor,
		// }
		'&:hover': {
			background: '#000'
		  }
	};

	useEffect(() => {
		if (windowWidth < 992) {
			setIsSmallScreen(true);
		} else {
			setIsSmallScreen(false);
		}
	}, [windowWidth]);


	useEffect(() => {
		if (!!bannerDiv?.offsetWidth && bannerDiv?.offsetWidth < 1050 && bannerDiv?.offsetWidth > 712) {
		  if (data.buttonTextPL.slice(0, -2) > 0)
			setbuttonTextPL((bannerDiv?.offsetWidth * data.buttonTextPL.slice(0, -2)) / 1365 + 'px',)
		  else 
			setbuttonTextPL(data.buttonTextPL)
		} else if (!!bannerDiv?.offsetWidth && bannerDiv?.offsetWidth <= 712 && data.buttonTextPL.slice(0, -2) > 0)
		  setbuttonTextPL('0px')
		else 
		  setbuttonTextPL(data.buttonTextPL)
	}, [bannerDiv?.offsetWidth])

	let primaryTextStyle = {
		marginTop: data.primaryTextMT,
		marginBottom: data.primaryTextMB,
		paddingLeft: data.primaryTextPL+'px',
		paddingRight: data.primaryTextPR+'px',
	}

	let secondaryStyle = {
		marginTop: data.secondaryTextMT,
		marginBottom: data.secondaryTextMB,
		paddingLeft: data.secondaryTextPL+'px',
		paddingRight: data.secondaryTextPR+'px',
	}
	let buttonStyle = {
		marginTop: data.buttonTextMT,
		marginBottom: data.buttonTextMB,
		paddingLeft: buttonTextPL,
		paddingRight: data.buttonTextPR,
	}
	let hoverClr = data.buttonHoverColor ? data.buttonHoverColor : "#FF7F00"

	const [textAlign, setTextAlign] = useState('bannerTextLeft')

	useEffect(() => {

		if (data.textAlign === '') {
			setTextAlign("bannerTextLeft")
		}
		else if (data.textAlign === 'banner-text-align-center') {
			setTextAlign("bannerTextCenter")

		} else if (data.textAlign === 'banner-text-align-right') {
			setTextAlign("bannerTextRight")
		}
	}, [data.textAlign]);

	return (
		<div className={`caption_block ${(data.popupImage === "" || data.popupImage === undefined || data.popupImage === "undefined" ) ? 
			"col-xl-12 col-lg-12 col-md-12 col-12 col-sm-12":"col-xl-6 col-lg-6 col-md-6 col-12 col-sm-6"}  `}
			style={{ padding: '0 ' + bannerWidth + 'px' }}
		>
			<style>
				{`.dtn_over${data?._id}{
					border-color:${data?.btnBordercolor} !important
					}
					.dtn_over${data?._id}:hover {
                                background: ${hoverClr} !important;
								border-color:${data?.buttonBorderHoverColor} !important;
								
                    }`
				}
				
			</style>
			<div className="slider-content slider-animated-1">
				{data?.bannerImageLink &&
					<a href={data?.bannerImageLink} className="bannerImageLink"></a>
				}

				<div className="edit-inline">
					<EditBannerIcon bannerId={bannerId} fromEditAction="bgImg" />
				</div>
				{
					(isSmallScreen === true && data?.primaryTextMobile) ?
						<div className="edit-inline primaryText" style={primaryTextStyle}>
							<EditBannerIcon bannerId={bannerId} fromEditAction="primaryText" />
							<h1 className={`w-100 animated dd ${data.primaryTextAnimationDelay} ${data.primaryTextAnimationName}`} dangerouslySetInnerHTML={{ __html: data.primaryTextMobile }} />
						</div> : <div className="edit-inline primaryText" style={primaryTextStyle}>
							<EditBannerIcon bannerId={bannerId} fromEditAction="primaryText" />
							<h1 className={`w-100 animated ${data.primaryTextAnimationDelay} ${data.primaryTextAnimationName}`} dangerouslySetInnerHTML={{ __html: data.primaryText }} />
						</div>
				}
				
				{
					(isSmallScreen === true && data?.secondaryTextMobile) ?
						<div className="edit-inline secondaryText" style={secondaryStyle}>
							<EditBannerIcon bannerId={bannerId} fromEditAction="secondaryText" />
							<h3 className={`w-100 animated ${data.secondaryTextAnimationDelay} ${data.secondaryTextAnimationName}`} dangerouslySetInnerHTML={{ __html: data.secondaryTextMobile }} />
						</div> : <div className="edit-inline secondaryText" style={secondaryStyle}>
							<EditBannerIcon bannerId={bannerId} fromEditAction="secondaryText" />
							<h3 className={`w-100 animated ${data.secondaryTextAnimationDelay} ${data.secondaryTextAnimationName}`} dangerouslySetInnerHTML={{ __html: data.secondaryText }} />
						</div>
				}

				<div className={`edit-inline ${textAlign}`} style={buttonStyle}>
					<EditBannerIcon bannerId={bannerId} fromEditAction="buttonDesign" />
					{data.showButton && (
						<div className="slider-btn-spring">
							{document.documentElement.style.setProperty('--bannerBtnBorder', data.btnBordercolor)}
							<BannerButton
								url={data.buttonUrl}
								data={data}
							/>
						</div>
					)}
				</div>
			</div>
		</div>
	)

};

HeroSliderOneItem.propTypes = {
	data: PropTypes.object,
	sliderClassName: PropTypes.string
};

export default HeroSliderOneItem;
